<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :filename="
        'Sole Proprietorship Industry Financial Profile - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="pdf_docs prfl-pdf">
        <!-- <div class="pdf_docs prfl-pdf"> -->
        <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page1" class="banner page">
            <div class="section_body">
              <img src="/img/pdf_logo.png" alt class="company_logo" />
              <h1>Sole Proprietorship Industry Financial Profile</h1>
              <h6>{{ this.headerInfo.industry }}</h6>
              <ul>
                <li>
                  Market Area:
                  <span>{{ this.headerInfo.area }}</span>
                </li>
                <!-- <li>
                                        Sales Class:
                                        <span>{{ this.headerInfo.sales_class }}</span>
                                    </li> -->
              </ul>
              <div class="bottom_area">
                <div class="left">
                  <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt />
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                </div>
                <div v-if="this.headerInfo.developer_name" class="right">
                  <h5>Developed By</h5>
                  <h3>{{ this.headerInfo.developer_name }}</h3>
                </div>
              </div>
            </div>
            <div class="banner_footer">
              <!-- <h6>American Author</h6>-->
              <span class="author"><!--Joyce Meyer--> </span>
              <span class="date">{{
                moment(new Date()).format("MMM Do YYYY")
              }}</span>
            </div>
          </div>
        </section>
        <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page2" class="company_info abut-list bg-grey page">
            <div class="section_body">
              <ul class="blue-crcl">
                <li>
                  <h5>About the Data</h5>
                  <p>Data Sources and Limitations</p>
                  <span class="grn-color">3</span>
                </li>
                <li>
                  <p>information</p>
                  <p>
                    Industry Peer Group <br />Industry In Context: The NAICS
                    Classification System <br />Ratio Categories
                  </p>
                  <span class="grn-color">4</span>
                </li>
                <li>
                  <h5>Profit & Loss</h5>
                  <p>% Percentages <br />Dollars</p>
                  <span class="grn-color">6</span>
                </li>
                <li>
                  <h5>Financial Ratios</h5>
                  <p>
                    Cash Flow-Slovency <br />Profitability <br />Efficiency
                    <br />Debt-Risk
                  </p>
                  <span class="grn-color">8</span>
                </li>
                <li>
                  <h5>Cash Tables</h5>
                  <p>% Percentages <br />Dollars</p>
                  <span class="grn-color">11</span>
                </li>
              </ul>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page3" class="about_info page">
            <div class="section_body">
              <div class="section_title">
                <h2>About the Data</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="negetive_margin">
                <div class="md-layout mt-4 mb-4">
                  <div class="md-layout-item md-size-40">
                    <div class="blue-box">
                      <span>Bizminer</span> data is widely accepted for industry
                      analytical work, benchmarking, valuations, forensics and
                      litigation. Bizminer content is accepted in US Tax Court
                      (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by
                      state, provincial and national taxing agencies in the US
                      and Canada.
                    </div>
                  </div>
                  <div class="md-layout-item md-size-60 info-text">
                    <p>
                      Raw data analyzed for Bizminer reports is sourced from an
                      array of the nation's government and private statistical
                      sources. None of these raw data sources creates the final
                      measures reflected in Bizminer industry profiles. In
                      total, Bizminer accesses over a billion sourced data
                      points from 15 million business operations for each of its
                      twice annual updates covering a 3-5 year time series.
                      Historical data and Bizminer algorithms are used to inform
                      and test projections for non-reporting firms. Data
                      elements are sourced specifically from:
                    </p>

                    <p>
                      While 100% firm coverage is desirable for analysis
                      purposes, the greatest value of Bizminer reports rests in
                      discerning patterns of activity, which are reflected in
                      the large samples used to develop our reports. The overall
                      current coverage of the databases surpasses 13 million
                      active business operations at any point in time. As is the
                      case with any databases this large, some errors are
                      inevitable. Some firms are missed and specific information
                      on others is lacking from the database. Not all
                      information received is uniform or complete, resulting in
                      the need to develop projection algorithms for specific
                      industry segments and metrics in some report series. No
                      representation is made as to the accuracy of the databases
                      utilized or the results of subsequent analyses.
                    </p>
                  </div>
                </div>
              </div>
              <div class="list_box blue-tick">
                <ul>
                  <li>IRS SOI Corporation Tax Book</li>
                  <li>IRS Statistics of Income</li>
                  <li>US Economic Census</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census County Business Patterns</li>
                  <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                  <li>
                    Bureau of Labor Statistics Monthly Unemployment Reports
                  </li>
                  <li>Bureau of Labor Statistics Annual Wage Survey</li>
                  <li>Bureau of Labor Statistics Industry Productivity</li>
                  <li>Reports</li>
                  <li>Bureau of Labor Statistics Price Indices</li>
                  <li>National Agricultural Statistical Service</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census Retail Trade Report</li>
                  <li>Data Axle</li>
                  <li>Business Valuation Resources (BVR)</li>
                  <li>Credit Reporting Agencies</li>
                  <li>Business Directories</li>
                  <li>American Community Survey</li>
                </ul>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page4" class="insight_sec page">
            <SPIFPdfIntroduction :information="information" />

            <!-- <div class="section_body">
                                <div class="section_title">
                                    <h2>Information</h2>
                                    <span class="date">{{ moment(new Date()).format('MMM Do YYYY') }}</span>
                                </div>
                                <div class="negetive_margin"  v-if="chartInfo" >
                                    <div class="md-layout md-alignment-bottom-center">
                                        <div class="md-layout-item md-size-40">
                                            <div class="table_sec change-sec mt-4">
                                                <div class="tbl-title"><p>Industry Peer Group</p></div>
                                                <md-table v-model="information.tableDataFirmsAnalyzed">
                                                <md-table-row
                                                slot="md-table-row"
                                                slot-scope="{ item }"
                                                >
                                                <md-table-cell
                                                md-label="Profile Year"
                                                md-sort-by="year"
                                                >
                                                {{ item.year }}
                                                </md-table-cell>
                                                <md-table-cell md-label="Firms">
                                                {{ item.firms }}
                                                </md-table-cell>
                                                </md-table-row>
                                                </md-table>
                                            </div>
                                        </div>
                                        <div class="md-layout-item md-size-60 mt-4">
                                             <div v-if="chartInfo && chartInfo !== {} && chartInfo.colouredLineChart && chartInfo.colouredLineChart.data.series[0]">
                                             <BarChart :categories="chartInfo.colouredLineChart.data.labels" :chartdata="chartData" />

                                            </div>
                                        </div>
                                        <div class="md-layout-item md-medium-size-100 md-size-100 mt-4 pt-4 mb-4">
                                            <div class="tbl-title"><h4>Your Industry In Context: The NAICS Classification System</h4></div>
                                            <div class="white_space p-4">
                                                <p class="px-4">
                                                    The industry your selected fits within the official
                                                    NAICS (North American Industry Classification
                                                    System) and Bizminer’s proprietary taxonomy, which
                                                    breaks out more detailed industries classifications
                                                    than NAICS by adding up to eight decimal digits
                                                    after the NAICS-6 code. The industry you selected
                                                    fits into this industry hierarchy:
                                                </p>
                                                <ul>
                                                    <li
                                                    v-for="(value, key) in information.naicsDrilldown"
                                                    :key="key"
                                                    >
                                                    NAICS: {{ key }} - {{ value }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page5" class="insight_sec page">
            <div class="section_body">
              <div class="md-layout terms bg-transparent p-0">
                <div class="md-layout-item md-size-100 p-0">
                  <div class="table_sec">
                    <div class="tbl-title"><h4>Ratio Categories</h4></div>
                    <p class="">
                      The Bizminer Industry Financial Priofile is based on
                      selected financial ratios that are typically considered to
                      be Key Performance Indicators (KPIs) which includes:
                    </p>
                  </div>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <p>Cash Flow/Solvency:</p>
                  <p>
                    Cash Flow ratios indicate a company’s ability to meet
                    various levels of demand on cash and easily obtainable cash
                    resources against current and anticipated near-term payments
                    due.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Profitability:</h6>
                  <p>
                    Profitability ratios compare levels of return against
                    various expense and balance sheet components to measure your
                    performance against reasonable industry peer group
                    standards, indicating bottom line performance.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Efficiency:</h6>
                  <p>
                    Efficiency ratios measure your success in marshalling
                    resources at hand to effectively manage various components
                    of your business operations. These indicators often point
                    most specifically toward actions that could enhance your
                    bottom line.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Debt-Risk:</h6>
                  <p>
                    Debt-Risk ratios assess the appropriateness of a firm’s
                    level of debt against the ability to pay, as well as the
                    risk of insolvency.
                  </p>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page6" class="value_multiples page">
            <SPIFProfitloss />
          </div>
        </section>

        <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page7" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <SPIFProfitlossDollars />
            <!-- </div> -->
          </div>
        </section>
        <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page8" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <SPIFRatios />
            <!-- </div> -->
          </div>
        </section>

        <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page9" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <SPIFCashTables />
            <!-- </div> -->
          </div>
        </section>

        <!-- </div> -->
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import SPIFPdfIntroduction from "./SPIFPdfIntroduction.vue";
import SPIFProfitloss from "./SPIFProfitloss.vue";
import SPIFRatios from "./SPIFRatios.vue";
import SPIFCashTables from "./SPIFCashTables.vue";
import SPIFProfitlossDollars from "./SPIFProfitlossDollars.vue";

export default {
  methods: {
    reverseArray(a) {
      var rA = [];
      for (var i = a.length; i > 0; i--) {
        rA.push(a[i - 1]);
      }

      return rA;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.$store.commit("user/SET_PDF_LOADING", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;

      let pages = [
        page1,
        page2,
        page3,
        page4,
        page5,
        page6,
        page7,
        page8,
        page9,
      ];

      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    filterNode(node) {
      if (node instanceof Text) {
        return true;
      }
      return (
        [
          "div",
          "span",
          "p",
          "i",
          "strong",
          "main",
          "aside",
          "article",
          "pre",
          "code",
          "time",
          "address",
          "header",
          "footer",
        ].includes(node.tagName.toLowerCase()) ||
        /^h[123456]$/i.test(node.tagName)
      );
    },
    convertImages() {},
  },
  components: {
    VueHtml2pdf,
    SPIFPdfIntroduction,
    SPIFProfitloss,
    SPIFRatios,
    SPIFCashTables,
    SPIFProfitlossDollars,
  },
  props: ["headerInfo", "information", "valMultiples"],
  data() {
    return {
      tableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      chartInfo: false,
      chartLoaded: false,
      xaxis: {
        labels: {
          style: {
            colors: ["#FFFFFF"],
          },
        },
      },
      moment: moment,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
    chartData() {
      return [
        {
          name: "series-1",
          data: this.reverseArray(
            this.chartInfo.colouredLineChart.data.series[0]
          ),
        },
      ];
    },
  },
  watch: {
    information: function(newVal, oldVal) {
      this.chartLoaded = true;
      this.chartInfo = newVal;
    },
  },
};
</script>
